import { userStore } from '@/store';
import pinia from '@/store/store';
export function createPageGuard(router) {
    router.beforeEach((to, from, next) => {
        const store = userStore(pinia);
        const token = store.token;
        if (to.path === '/') {
            // 场景1：访问根路径 / → 无论有无Token，跳转到登录页（满足原有需求）
            next('/login');
        }
        else if (to.path === '/login') {
            // 场景2：主动访问 /login 页面 → 直接放行，允许回到登录页（关键修复）
            next();
        }
        else {
            // 场景3：访问其他页面（非 /、非 /login）
            if (!token) {
                // 无Token → 拦截，重定向到登录页（此时跳转到 /login 后会放行，无循环）
                next('/login');
            }
            else {
                // 有Token → 正常放行，可进入任何其他页面
                next();
            }
        }
    });
}
//# sourceMappingURL=guard.js.map